<template>
  <div class="modal fade newAnnouncementModal" :id="modalId" tabindex="-1" role="dialog" aria-labelledby="newAnnouncementModal" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">

        <form  v-if="parentType==='confirmation'">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Please Select The Type Task</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <div class="form-group">
                <div class="row mt-20">
                  <div class="col-md-6 col-lg-6 col-sm-4">
                    <label class="w-100">
                      <input type="radio" name="product" selected checked class="card-input-element btn-check disable_pointer"  v-model="taskConfirmation" id="exampleRadios11"  @input="changeParentType" value=true />
                      <div class="card-default card-input custom-card ">
                        <div class="card-header text-center font-weight-bold"> Sales Task</div>
                      </div>
                    </label>
                  </div>
                  <div class="col-md-6 col-lg-6 col-sm-4">
                    <label class="w-100" >
                      <input type="radio" name="product" class="card-input-element btn-check disable_pointer" v-model="taskConfirmation" id="exampleRadios12" @input="changeParentType" value=false />
                      <div class="card-default card-input custom-card">
                        <div class="card-header text-center font-weight-bold">Support Task</div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <form  v-else @submit.prevent="submit">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ modalText }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <div class="form-group" v-if="modalText==='Create Task'">
                <label>Service Type*</label>
                <div class="row">
                  <!--                  <div class="col-md-6 col-lg-2 col-sm-4">-->
                  <!--                  </div>-->
                  <div class="col-md-6 col-lg-6 col-sm-4">
                    <label class="w-100">
                      <input type="radio" name="product" selected checked  class="card-input-element btn-check disable_pointer"  v-model="radioButton" id="exampleRadios11"  @input="resetValues" value="true" />
                      <div class="card-default card-input" :class="radioButton==='true' ? 'custom-card-active': 'custom-card'">
                        <div class="pt-30 pb-30 pr-4 text-center font-weight-bold text-primary"> WPO</div>
                      </div>
                    </label>
                  </div>
                  <!--                  <div class="col-md-6 col-lg-1 col-sm-4">-->
                  <!--                  </div>-->
                  <div class="col-md-2 col-lg-6 col-sm-4">
                    <label class="w-100">
                      <input type="radio" name="product" class="card-input-element btn-check disable_pointer"  v-model="radioButton" id="exampleRadios12" @input="resetValues" value="false" />
                      <div class="card-default card-input" :class="radioButton==='false' ? 'custom-card-active': 'custom-card'">
                        <div class="pt-30 pb-30  pr-4 pl-4 text-center font-weight-bold text-danger">NON WPO</div>
                      </div>
                    </label>
                  </div>
                  <div class="col-md-6 col-lg-2 col-sm-4">
                  </div>
                </div>
              </div>
              <label >Domain/Email*</label>
              <multi-select
                  v-if="radioButton === 'true'"
                  required
                  id="smart-search"
                  v-model="newTask.selectedDomain"
                  label="name"
                  track-by="id"
                  placeholder="Search User"
                  :options="searchList"
                  :multiple="false"
                  :searchable="true"
                  :loading="isLoading"
                  :internal-search="false"
                  :clear-on-select="false"
                  :close-on-select="true"
                  :options-limit="300"
                  :max-height="600"
                  group-values="data"
                  group-label="type"
                  :group-select="false"
                  :show-no-results="true"
                  @input="setValues"
                  @search-change="getSearchList">

                <template  slot="option" slot-scope="props">
                  <span v-if="props.option.$groupLabel" v-html="getHtmlForSearch(props.option.$groupLabel)" />
                  <span v-else>{{ props.option.name }}</span>
                </template>
                <span slot="noResult">No data available.</span>
              </multi-select>
              <input  v-else required type="text" v-model="newTask.domain" class="form-control">
            </div>
            <div class="form-group">
              <label>Ticket URL</label>
              <input type="text" v-model="newTask.ticketUrl" class="form-control">
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-md-6">
                  <label>Task Type*</label>
                  <select required class="form-control" v-model="newTask.taskType">
                    <option v-for="value in taskType" :value="value" :key="value">{{value}}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label>Priority* <i class="fa fa-question-circle ml-2 text-dark make-cursor-pointer" data-toggle="tooltip" data-placement="top" title="On the basis of priority, reminders will be sent to the respective channels in Slack. Low = every 24 hours Medium = every 12 hours High = every 3 hours"></i></label>
                  <select required class="form-control" v-model="newTask.priority">
                    <option value="low">Low</option>
                    <option value="medium">Medium</option>
                    <option value="high">High</option>
                  </select>
                </div>
              </div>
            </div>
            <div v-if="newTask.taskType === 'Other' && parentType === 'support'" class="form-group">
              <div class="row mt-20">
                <div class="col-md-6">
                  <div class="form-check-radio form-check-inline">
                    <label class="form-check-label">
                      <input class="form-check-input" type="radio" v-model="interlinkTask" id="exampleRadios12431" value=false>  Interlinked Task
                      <span class="form-check-sign"></span>
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-check-radio form-check-inline">
                    <label class="form-check-label">
                      <input class="form-check-input" type="radio" v-model="interlinkTask" id="exampleRadios1134"   value=true> Disjointed Task
                      <span class="form-check-sign"></span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="newTask.taskType === 'Storage Adjustment' && parentType === 'sales'" class="form-group">
              <div class="row">
                <div class="col-md-6">
                  <label>Previous Limit</label>
                  <input @input="addComment($event, 'prev')" placeholder="X GB" type="number" v-model="limit.prev" class="form-control">
                </div>
                <div class="col-md-6">
                  <label>New Limit</label>
                  <input @input="addComment($event, 'curr')" placeholder="X GB" type="number" v-model="limit.curr" class="form-control">
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-md-12">
                  <label>Assign</label>
                  <multi-select
                      id="smart-admin"
                      v-model="newTask.assign"
                      label="admin"
                      track-by="firstName"
                      placeholder="Select Admin"
                      :options="admin"
                      :custom-label="nameWithLang"
                      :show-labels="false"
                  >
                    <span slot="noResult">No data available.</span>
                  </multi-select>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col-md-12 pt-5" v-if="radioButton === 'false'">
                  <label>Client HostBill ID</label>
                  <input type="text" v-model="newTask.clientHostBillId" class="form-control">
                </div>
              </div>
            </div>
            <div class="form-group pd-4" v-if="radioButton === 'false'" >
              <label class="typo__label">HostBill Service ID</label>
              <multi-select
                  type="number"
                  v-model="hbServiceID"
                  tag-placeholder="Add Another Service ID tag"
                  placeholder="Add Host Bill Service ID"
                  :options="hbServiceID"
                  :option-height="10"
                  :multiple="true"
                  :taggable="true"
                  @tag="addHbServiceID"
                  openDirection="bottom"
              >
                <template slot="singleLabel" slot-scope="{ hbServiceID, remove }">
                  <input
                      type="number"
                      v-model="hbServiceID"
                  >
                  <span @click="remove(hbServiceID)">&times;</span>
                </template>
                <span slot="noOptions">No service id available.</span>
              </multi-select>

            </div>
            <div class="form-group">
              <label>Comments</label>
              <textarea :required="newTask.taskType === 'Other'" v-model="newTask.comment" class="form-control" rows="4"></textarea>
            </div>
            <div class="form-group" v-if="modalText === 'Create Task'">
              <button type="button" class="btn btn-secondary btn-sm" @click="addTaskList=true">Add checklist </button>
            </div>
            <div  v-if="addTaskList">
              <div class="mb-10 d-flex align-items-center">
                <input type="text" class="form-control" placeholder="Enter Task" aria-label="Task Details" aria-describedby="basic-addon2" v-model="taskItem">
                <button class="btn btn-light m-0 border-0" type="button" @click="addTaskToTaskList" :disabled="taskItemError"><i class="fa fa-plus-circle fa-2x "></i> </button>
              </div>
              <ul class="list-group ">
                <li class="list-group-item border-0 d-flex align-items-center ps-0 pt-0" v-for="item in newTask.taskList" :key="item.text" >
                  <input class="form-check-input" type="checkbox" v-model="item.isChecked"  @change="checkTaskList(item)"  />
                  <div class="mt-5">{{item.text.trim(1,100)}}</div>
                </li>
              </ul>

            </div>
          </div>
          <div class="modal-footer d-flex justify-content-between">
            <button type="button" class="btn btn-secondary btn-sm ml-25"  data-dismiss="modal" aria-label="Close">Close</button>
            <button type="submit" class="btn btn-primary btn-sm mr-25" >
              <div class="loader small_loader" v-if="adding"></div>
              <span v-else>Submit</span>
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import {db} from "@/firebase/init";
import swal from 'sweetalert2';
import _, {map} from "lodash";
import multiSelect from "vue-multiselect";
import Paginate from 'vuejs-paginate'
import md5 from "crypto-js/md5";
import statisticsMixin from "@/mixins/statisticsMixin";

export default {
  name: "ManualTaskModal",
  components: {multiSelect, Paginate},
  mixins: [statisticsMixin],
  props: {
    parentType: {
      required: true,
      type: String
    },
    changeType: {
      type: Function
    },
    modalId: {
      type: String
    }
  },
  data() {
    return {
      addTaskList: false,
      modalText: '',
      taskConfirmation: null,
      showLimit: false,
      limit: {
        prev: null,
        curr: null
      },
      interlinkTask: true,
      tasks: [],
      loading: false,
      adding: false,
      taskItemError: true,
      taskItem:'',
      newTask: {
        priority: 'low',
        ticketUrl: '',
        assign: {
          firstName: '',
          lastName: '',
          docID: '',
          email: ''
        },
        taskType : '',
        selectedUser: {
          firstName: null,
          lastName: null,
          clientId: null,
          id: null,
          email: null
        },
        clientEmail: null,
        clientId: null,
        selectedDomain: null,
        clientHostBillId : null,
        comment: '',
        domain: '',
        taskList: []
      },
      hbServiceID: [],
      radioButton: "true",
      filterOptions: ['high', 'medium', 'low', 'all'],
      options: [
      ],
      salesToSupportTaskTypes: ['Termination Check'],
      selectedId : 'null',
      admin: [],
      searchList: [],
      selectedUser: {},
      isLoading: false,
      selectedFilter: [],
      manualJobListener: null,
      testGroup: [],
      showRecords: 10,
      pageNumber: 0,
      selectedSalesToSupportTask : {},
      salesTask: [ 'Storage Adjustment', 'Service Cancellation', 'CF ENT Cancellation', 'Service Upgrade', 'Service Downgrade', 'Other'],
      manualTask: ['Downgrade','Upgrade', 'Logins Check' ,'Install WP', 'Email Migration' ,'Termination Check', 'Power Off Server', 'Server Setup','CF ENT Termination','Server Termination', 'Other']
    }
  },
  watch: {
    taskItem (value) {
      value = value.replace(/\s/g, '');
      if(value){
        this.taskItemError= false
      }
      else{
        console.log('Empty Field')
        this.taskItemError= true
      }
    }
  },
  computed: {
    user() {
      return this.$store.getters.user
    },
    taskType(){
      if(this.parentType==='support'){
        return this.manualTask;
      }
      else {
        return this.salesTask
      }
    },

  },
  mounted () {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })
    this.getAdmins();
  },
  methods: {
    checkTaskList(task){
      if(task.isChecked){
        task.checkedById= this.user.uid
        task.checkedBy= `${this.user.firstName} ${this.user.lastName}`
      }
      else{
        task.checkedById= false
        task.checkedBy= false
      }
    },
    changeParentType(event) {
      const flag= event.target.value;
      this.changeType(flag)
    },
    nameWithLang ({ firstName, lastName }) {
      if (!firstName && !lastName) {
        return 'None'
      }
      return `${firstName} ${lastName}`
    },
    addComment(event, type) {
      if (type === 'prev') {
        this.newTask.comment = this.newTask.comment.split('\n').filter(el => {
          return !el.startsWith('Previous Limit')
        }).join('\n')
        this.newTask.comment += `Previous Limit: ${event.target.value} GB \n`;
      } else if (type === 'curr') {
        this.newTask.comment = this.newTask.comment.split('\n').filter(el => {
          return !el.startsWith('New Limit')
        }).join('\n')
        this.newTask.comment += `New Limit: ${event.target.value} GB \n`;
      }
    },
    addHbServiceID (newID){
      this.hbServiceID.push(newID);
    },
    async getAdmins() {
      try{
        this.admin = [];
        const data = await db.collection("users").where("userType", "in", ['admin', 'manager', 'super-admin']).get();
        if (data.empty === true) {
          this.noUser = true;
        }
        if(data.size) {
          this.admin.push({
            firstName: '',
            lastName: '',
            email: '',
            docID: ''
          })
        }
        data.forEach(doc => {
          this.admin.push({
            docID: doc.id,
            ...doc.data()
          });
        });
      }
      catch(e){
        console.log('Error occurred while fetching admins');
      }
      finally {
        console.log('fetched admins in modal', this.admin);
      }
    },
    addTaskToTaskList(){
      this.newTask.taskList.push({isChecked: false , text: this.taskItem , checkedBy: false , checkedById: false})
      this.taskItem=''
    },
    fixModal(link=null) {
      this.newTask = {
        priority: 'low', ticketUrl: '', assign: '', taskType : '', selectedUser: {}, clientHostBillId : null, comment: '',  selectedDomain: '', taskList: []
      }
      this.taskItem=''
      this.hbServiceID= [];
      if(link===null){
        this.modalText='Create Task'
        this.radioButton= "true";
        this.addTaskList= false;  // only for Create Task
      }
      else{
        this.hbServiceID=[]
        this.modalText='Edit Task'
        console.log(link)
        this.radioButton=link.serviceType === 'WPO' ? "true": "false";
        const { email, name, uid } = link.assign || {};
        const [firstName = '', lastName = ''] = (name || '').split(" ");
        let inputString = link.comment || "";
        let comment = inputString.replace(/"/g, '');
        if( link.serviceType ==='WPO' ){
          this.newTask={
            selectedDomain:{name: link.domain ,email:link.hostBillID, clientId:link.clientId },
            id:link.id,
            priority: link.priority,
            ticketUrl: link.ticketURL,
            assign: {email,firstName, lastName ,uid },
            taskType : link.taskType,
            comment: comment,
            lastMessageSentAt :link.lastMessageSentAt,
            createdBy: link.createdBy,
            createdAt: link.createdAt
          }
        }
        else{
          this.newTask={
            domain: link.domain,
            clientHostBillId : link.clientId,
            id:link.id,
            priority: link.priority,
            ticketUrl: link.ticketURL,
            assign: {email,firstName, lastName ,uid },
            taskType : link.taskType,
            comment: comment,
            lastMessageSentAt :link.lastMessageSentAt,
            createdBy: link.createdBy,
            createdAt: link.createdAt
          }
        }
        link.limit ? this.limit= {
          curr: link.limit.curr || null,
          prev:  link.limit.prev || null,
        } : null
        this.newTask.taskList= link.taskList ?  link.taskList: [];
        this.hbServiceID=[...link.hbServiceId]
      }

      $(`#${this.modalId}`).modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");

      // $(document).ready(function() {
      //   $(".modal-backdrop").appendTo(".new-announcement-modal");
      // });

      /* eslint-enable */
    },
    async createInterLinkSalesTask(parentTask){
      try{
        await db.collection('manualTasks').add({
          assign: {
            name:'' ,
            uid: '',
            email: ''
          },
          limit: this.limit,
          linkedTask: parentTask,
          hostBillID:  parentTask.hostBillID,
          hbServiceId:  parentTask.hbServiceId,
          serviceType: parentTask.serviceType,
          clientId: parentTask.clientId,
          comment: '',
          domain: parentTask.domain,
          priority:parentTask.priority,
          taskType: parentTask.taskType,
          ticketURL:parentTask.ticketURL,
          resolved: false,
          type: 'sales',
          taskList: parentTask.taskList,
          lastMessageSentAt: new Date().toISOString(),
          createdBy: `${this.user.firstName} ${this.user.lastName}`,
          createdAt:  new Date().toISOString(),
        });
      }
      catch(e){
        console.log("Failed to create sales task")
        console.log(e)
      }
    },
    async submit (){
      try{
        if(this.modalText=== 'Create Task'){
          await this.submitLink()
        }
        else{
          await this.editLink()
        }
      }
      catch(e){
        console.log(e.toString(), 'Error Occurred in submitting')
      }
    },
    async editLink () {
      try {
        if (this.radioButton === 'true' && !this.newTask.selectedDomain) {
          swal('Missing Fields', 'Domain is not selected. Please select domain first!', 'error')
          return false;
        }
        this.adding = true;
        const HostBillUser = this.radioButton === 'true' ? this.newTask.selectedDomain.email : this.newTask.clientHostBillId;
        const clientEmail = this.radioButton ==='true' ? this.newTask.selectedDomain.name : this.newTask.domain
        this.newTask.comment = this.newTask.comment.replace(/\s+/g, ' ').replace(/\n/g, '').trim();
        const task = {
          assign: {
            name:`${this.newTask.assign.firstName} ${this.newTask.assign.lastName}` ,
            uid: this.newTask.assign.docID || '',
            email: this.newTask.assign.email || ''
          },
          limit: this.limit,
          hostBillID: HostBillUser,
          hbServiceId: [...this.hbServiceID],
          serviceType: this.radioButton==='true' ? 'WPO' : 'NON-WPO',
          clientId: this.radioButton === 'true' ? this.newTask.selectedDomain.clientId : this.newTask.clientHostBillId,
          comment: JSON.stringify(this.newTask.comment),
          domain: clientEmail,
          priority: this.newTask.priority,
          taskType: this.newTask.taskType,
          ticketURL: this.newTask.ticketUrl,
          resolved: false,
          type: this.parentType,
          taskList: this.newTask.taskList || [],
          lastMessageSentAt: this.newTask.lastMessageSentAt,
          createdBy: this.newTask.createdBy,
          createdAt:  this.newTask.createdAt,
          updatedAt:  new Date().toISOString(),
        }
        const ref =  await db.collection('manualTasks').doc(this.newTask.id).update({...task});
        if(this.interlinkTask ==='false'){
          await this.createInterLinkSalesTask(task)
        }
        const response = await this.$http.post('/utilities/send_manual_task_to_slack', {
          grant_type: 'token',
          assign: {
            name:`${this.newTask.assign.firstName} ${this.newTask.assign.lastName}` ,
            uid: this.newTask.assign.docID,
            email: this.newTask.assign.email
          },
          type: this.parentType,
          taskType: this.newTask.taskType,
          priority: this.newTask.priority,
          comment: this.newTask.comment,
          domain: clientEmail,
          createdBy: this.user.firstName + ' ' + this.user.lastName,
          taskId: this.newTask.id
        })
        console.log(response)
        $(`#${this.modalId}`).modal('hide');
      } catch (e) {
        console.log(e)
        // $("#newAnnouncementModal").modal('hide');
        swal({
          title: "Error",
          text: "Something went wrong while adding manual task! " + e.toString(),
          type: "error",
        });
      } finally {
        this.adding = false;
      }
    },
    async submitLink () {
      try {
        if (this.radioButton === 'true' && !this.newTask.selectedDomain) {
          swal('Missing Fields', 'Domain is not selected. Please select domain first!', 'error')
          return false;
        }

        this.adding = true;
        const HostBillUser = this.radioButton === 'true' ? this.newTask.selectedDomain.email : this.newTask.clientHostBillId;
        const clientEmail = this.radioButton ==='true' ? this.newTask.selectedDomain.name : this.newTask.domain
        this.newTask.comment = this.newTask.comment.replace(/\s+/g, ' ').replace(/\n/g, '').trim();
        this.newTask.taskList = this.newTask.taskList ? this.newTask.taskList : [];
        const task = {
          assign: {
            name:`${this.newTask.assign.firstName} ${this.newTask.assign.lastName}` ,
            uid: this.newTask.assign.docID || '',
            email: this.newTask.assign.email || ''
          },
          limit: this.limit,
          hostBillID: HostBillUser,
          hbServiceId: this.hbServiceID,
          serviceType: this.radioButton==='true' ? 'WPO' : 'NON-WPO',
          clientId: this.radioButton === 'true' ? this.newTask.selectedDomain.clientId : this.newTask.clientHostBillId,
          comment: JSON.stringify(this.newTask.comment),
          domain: clientEmail,
          priority: this.newTask.priority,
          taskType: this.newTask.taskType,
          ticketURL: this.newTask.ticketUrl,
          resolved: false,
          type: this.parentType,
          taskList: this.newTask.taskList || [],
          lastMessageSentAt: new Date().toISOString(),
          createdBy: `${this.user.firstName} ${this.user.lastName}`,
          createdAt:  new Date().toISOString(),
        }
        console.log('task task', task)
        const ref =  await db.collection('manualTasks').add({...task});
        if(this.interlinkTask ==='false'){
          await this.createInterLinkSalesTask(task)
        }
        const response = await this.$http.post('/utilities/send_manual_task_to_slack', {
          grant_type: 'token',
          assign: {
            name:`${this.newTask.assign.firstName} ${this.newTask.assign.lastName}` ,
            uid: this.newTask.assign.docID,
            email: this.newTask.assign.email
          },
          type: this.parentType,
          taskType: this.newTask.taskType,
          priority: this.newTask.priority,
          comment: this.newTask.comment,
          domain: clientEmail,
          createdBy: this.user.firstName + ' ' + this.user.lastName,
          taskId: ref.id
        })
        console.log(response)
        $(`#${this.modalId}`).modal('hide');
      } catch (e) {
        console.log(e)
        // $("#newAnnouncementModal").modal('hide');
        swal({
          title: "Error",
          text: "Something went wrong while adding manual task! " + e.toString(),
          type: "error",
        });
      } finally {
        this.adding = false;
      }
    },
    async getSearchList(query) {
      if (query.length > 0) {
        this.isLoading = true;
        let customers = [];
        let domains = [];
        const searchRef = await this.$http.post("algolia/search", {
          grant_type: "token",
          query
        });
        if(query.includes('@')){
          let customersObjects = _.groupBy(searchRef.data, function(item) {
            // console.log(item)
            return item.uid
          })
          _.forEach(customersObjects, function(arrr, key) {
            if (arrr[0].customerID !== '-1') {
              customers.push({
                id: key,
                name: arrr[0].email,
                fullName: `${arrr[0].firstName} ${arrr[0].lastName}`,
                clientId: arrr[0].customerID,
                email: arrr[0].email,
                firstName: arrr[0].firstName,
                lastName: arrr[0].lastName,
              })
            }
          })
        }
        else{
          map(searchRef.data, (item) => {
            if (item.domain) {
              let accountDetail = {
                id: item.uid,
                name: `${item.domain} u: ${item.firstName} ${item.lastName} ip: ${item.serverIP}`,
                clientId: item.customerID,
                fullName: `${item.firstName} ${item.lastName}`,
                email: item.email,
                firstName: item.firstName,
                lastName: item.lastName,
              };
              let domain = {
                id: item.uid,
                name: `${item.domain}`,
                clientId: item.customerID,
                email: item.email,
                fullName: `${item.firstName} ${item.lastName}`,
                firstName: item.firstName,
                lastName: item.lastName,
              };
              domains.push(domain)
            }
          });
        }
        this.searchList = [
          {
            type: 'Customers',
            icon: '<i class="fa fa-user"></i>',
            data: customers
          },
          {
            type: 'Domains',
            icon: '<i class="fa fa-globe"></i>',
            data: domains
          },
        ];
        this.isLoading = false;

      } else {
        this.searchList = [];
      }
    },
    getHtmlForSearch (label) {
      switch (label) {
        case 'Domains':
          return '<i class="fa fa-globe mr-5" /> <span>Domains</span>'
        case 'Customers':
          return '<i class="fa fa-users mr-5" /> <span>Customers</span>'
      }
    },
    async setValues(value) {
      this.newTask.selectedUser = {
        id: value.id,
        firstName: value.firstName,
        lastName: value.lastName,
        email: value.email,
        clientId: value.clientId
      }
      this.newTask.clientEmail = value.email
      await this.getHostingServiceId(value.id , value.name)
    },
    async getHostingServiceId(docID , domain){
      try{
        const query = await db.collection('hostingAccounts').doc(docID).get();
        if (!query.exists) throw new Error('Hosting account not found');
        const { accounts } = query.data();
        accounts.forEach((value)=>{
          const {primary} = value;
          const hbServiceID= primary.hbServiceID
          console.log(hbServiceID)
          if(primary.domain === domain){
            this.hbServiceID =[hbServiceID]
            return
          }
          const {addon} = value;
          addon.forEach((addonDomain)=>{
            if(addonDomain.domain === domain){
              this.hbServiceID=[hbServiceID]
              return
            }
          })
        })
      }
      catch(e){
        console.log(e)
      }
    },
    resetValues(){
      this.newTask = {
        priority: 'low', ticketUrl: '', assign: '', taskType : '', selectedUser: {}, clientHostBillId : null, comment: '', taskList: []
      }
      this.addTaskList= false
      this.hbServiceID= [];
    }
  }
}
</script>

<style>
.disable_pointer{
  display: none;
  border:  1px solid black;
}
.custom-card-active{
  cursor: pointer;
  border: 2px solid black;
  border-radius: 10px;
}
.custom-card{
  cursor: pointer ;
  border: 2px solid lightgray;
  border-radius: 10px;
}

</style>
